"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaTypes = exports.Genders = exports.Store = void 0;
const mobx_1 = require("mobx");
const rich_agent_1 = require("rich-agent");
const react_mobx_loader_1 = require("react-mobx-loader");
class Store {
    constructor(endpointStore) {
        this._endpointStore = endpointStore;
        this._postRequest = new rich_agent_1.ApiRequest(this._endpointStore.endpoint + '/press/contact', 'POST');
        this.postLoader = new react_mobx_loader_1.CustomLoader(this._postRequest, false);
    }
    save(values) {
        if (this.postLoader.status !== 'pending') {
            return this._postRequest
                .send(values);
        }
        return new Promise((resolve, reject) => {
            reject();
        });
    }
}
__decorate([
    mobx_1.observable
], Store.prototype, "postLoader", void 0);
exports.Store = Store;
exports.Genders = ['male', 'female'];
exports.MediaTypes = ['other', 'radio', 'press', 'tv'];
